import { LocalStorageKey } from '../constants/localStorageKeys';
import React, { useContext } from 'react';
export const BgDataContext = React.createContext([
    { id: '', naam: '' },
    () => {
        /* void */
    },
]);
export const bgDataReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { id: action.payload.id, naam: action.payload.naam });
};
const clearBgData = () => {
    localStorage.removeItem(LocalStorageKey.SelectedBG);
};
const setBgLocalStorage = (bgId, bgNaam) => {
    try {
        localStorage.setItem(LocalStorageKey.SelectedBG, JSON.stringify({ id: bgId, naam: bgNaam }));
    }
    catch (error) {
        console.error('Error when trying to set item in sessionStorage', error);
        localStorage.removeItem(LocalStorageKey.SelectedBG);
    }
};
export function useBgData() {
    let selectedBg;
    try {
        selectedBg = JSON.parse(localStorage.getItem(LocalStorageKey.SelectedBG) || '[]');
    }
    catch (error) {
        console.error('Error when trying to retrieve item in sessionStorage', error);
        localStorage.removeItem(LocalStorageKey.SelectedBG);
    }
    const [state, dispatch] = useContext(BgDataContext);
    return {
        bgData: localStorage.getItem(LocalStorageKey.SelectedBG) ? selectedBg : state,
        setBgData: dispatch,
        clearBgLocalStorage: clearBgData,
        setBgLocalStorage: setBgLocalStorage,
    };
}
